// extracted by mini-css-extract-plugin
export var formContainer = "PartnerForm-module--formContainer--HFbiv";
export var formContent = "PartnerForm-module--formContent--X5HQn";
export var formDescription = "PartnerForm-module--formDescription--m8JBS";
export var formHeader = "PartnerForm-module--formHeader--Nb7Fz";
export var formImage = "PartnerForm-module--formImage--9TIPC";
export var formSectionWrapper = "PartnerForm-module--formSectionWrapper--pteu6";
export var formSubtitle = "PartnerForm-module--formSubtitle--JEj5U";
export var formTitle = "PartnerForm-module--formTitle--PYXM8";
export var headerSection = "PartnerForm-module--headerSection--K8aPT";
export var imageContainer = "PartnerForm-module--imageContainer--2JK2J";
export var mainDescription = "PartnerForm-module--mainDescription--1Vaq6";
export var mainTitle = "PartnerForm-module--mainTitle--FYPbH";